import { useState } from 'react';
import { Dialog, DialogActions } from '../ui/Dialog';
import { Button } from '../ui/Button';
import { deleteItem } from '../db/items';
import type { Item } from '../db/schema';

/**
 * Names the item, because the photo is the only copy — the listing it came
 * from may not exist any more. The confirm button is `--oxblood`, which
 * appears nowhere but here and the room's version of this dialog.
 */
export function DeleteItemDialog({
  item,
  onClose,
  onDeleted,
}: {
  item: Item;
  onClose: () => void;
  onDeleted: (item: Item) => void;
}) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | undefined>(undefined);

  async function confirm() {
    setBusy(true);
    setError(undefined);
    try {
      await deleteItem(item.id);
      onDeleted(item);
    } catch {
      setError("That item couldn't be deleted. Nothing was removed.");
      setBusy(false);
    }
  }

  return (
    <Dialog title={`Delete ${item.title}?`} onClose={onClose}>
      <p>Its photos go too. This can&rsquo;t be undone.</p>

      {error !== undefined && (
        <p className="dialog__error" role="alert">
          {error}
        </p>
      )}

      <DialogActions>
        <Button variant="quiet" onClick={onClose} disabled={busy}>
          Keep It
        </Button>
        <Button variant="destructive" onClick={() => void confirm()} disabled={busy}>
          Delete Item
        </Button>
      </DialogActions>
    </Dialog>
  );
}
